import React from 'react';
import './style.scss';
import clsx from 'clsx';

const CustomTextFieldAdornment = ({ content }) => {
  if (!content) return null;

  return (
    <div className={clsx('ctf-adornment', typeof content === 'string' && 'ctf-adornment-text')}>
      {content}
    </div>
  );
};

export default CustomTextFieldAdornment;
